(() => {
  function revealHash() {
    if (!location.hash) return;
    let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target) return;
    const details = target.closest('details');
    if (details) details.open = true;
    if (target.matches('details')) target.open = true;
  }
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#remain-"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target?.matches('details')) target.open = true;
  });
  revealHash();
})();